import styled from 'styled-components';
import { BREAKPOINTS, MEDIA } from '../../../constants/breakpoints';
import { WORKSPACE_BG, CARD_BG, CARD_SHADOW } from '../../../constants/colors';

export const AppLayout = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: ${WORKSPACE_BG};
  padding: 10px;
  box-sizing: border-box;

  ${MEDIA.MOBILE} {
    padding: 0;
  }
`;

export const AppLayout__Sidebar = styled.div<{ $open: boolean; $collapsed: boolean }>`
  flex-shrink: 0;
  width: ${(props) => (props.$collapsed ? BREAKPOINTS.SIDEBAR_COLLAPSED_WIDTH : BREAKPOINTS.SIDEBAR_WIDTH)};
  height: 100%;
  z-index: 100;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  ${MEDIA.MOBILE} {
    width: ${BREAKPOINTS.SIDEBAR_WIDTH};
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    transform: translateX(${(props) => (props.$open ? '0' : '-100%')});
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

export const AppLayout__Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100%;
  border-radius: 16px;
  background: ${CARD_BG};
  box-shadow: ${CARD_SHADOW};
  overflow: hidden;

  ${MEDIA.MOBILE} {
    border-radius: 0;
    box-shadow: none;
  }
`;

export const AppLayout__Backdrop = styled.div<{ $visible: boolean }>`
  display: none;

  ${MEDIA.MOBILE} {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 99;
    opacity: ${(props) => (props.$visible ? 1 : 0)};
    pointer-events: ${(props) => (props.$visible ? 'auto' : 'none')};
    transition: opacity 0.3s ease;
  }
`;
